import { useEffect, useState } from "react";
import styles from "./index.module.scss";

export enum TurnDirection {
  None,
  Left,
  Right,
}

interface TurnstileProps<T extends React.ComponentType> {
  left: T;
  right: T
  dir: TurnDirection;
  dur: number;
}

const Turnstile = <T extends React.ComponentType,>(props: TurnstileProps<T>) => {
  const [left, setLeft] = useState(props.dir !== TurnDirection.Right);
  const Left = props.left as React.ComponentType<{}>;
  const Right = props.right as React.ComponentType<{}>;

  useEffect(() => {
    setTimeout(() => setLeft(x => !x), props.dur/2);
  }, [props.dir]);

  return (
    <div className={styles.turnstile}>
      <div 
        className={
          props.dir === TurnDirection.Left 
          ? styles.left 
          : props.dir === TurnDirection.Right 
          ? styles.right 
          : undefined
        }
        style={{animationDuration: `${props.dur}ms`}}
      >
        { left ? <Left/> : <Right/> }
      </div>
    </div>
  );
};

export default Turnstile;